import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Dropdown,
    Option,
} from "@fluentui/react-components";
import { useRole } from "../RoleContext";
import { AppRole } from "../../../api/types";

const RoleSwitcher: React.FC = () => {
    const { activeRole, validRoles, setActiveRole } = useRole();
    const [open, setOpen] = React.useState(false);
    const [pendingRole, setPendingRole] = React.useState<AppRole>(activeRole);

    if (validRoles.length <= 1) {
        return null;
    }

    const handleOpen = () => {
        setPendingRole(activeRole);
        setOpen(true);
    };

    const handleConfirm = () => {
        setActiveRole(pendingRole);
        setOpen(false);
    };

    return (
        <>
            <Button appearance="subtle" onClick={handleOpen} size="small">
                Switch role
            </Button>
            
            <Dialog open={open} onOpenChange={(_e, data) => setOpen(data.open)}>
                <DialogSurface style={{ maxWidth: "300px" }}>
                    <DialogBody>
                        <DialogTitle>Switch Role</DialogTitle>
                        <DialogContent>
                            <Dropdown
                                value={pendingRole}
                                selectedOptions={[pendingRole]}
                                onOptionSelect={(_e, data) => {
                                    if (data.optionValue) {
                                        setPendingRole(data.optionValue as AppRole);
                                    }
                                }}
                            >
                                {validRoles.map((role) => (
                                    <Option key={role} value={role}>
                                        {role}
                                    </Option>
                                ))}
                            </Dropdown>
                        </DialogContent>
                        <DialogActions>
                            <Button appearance="primary" onClick={handleConfirm}>
                                Confirm
                            </Button>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </>
    );
};

export default RoleSwitcher;
